module.exports = __webpack_public_path__ + "static/SanjivAgarwal-4d8c7607cd2f0183facc900ecbfda8e7.jpg";